export type ProductImageLanguage = "sv" | "en";

export interface ProcessedProductMedia {
  mainImage?: string;
  imageGallery?: string[];
  mainImage_sv?: string;
  mainImage_en?: string;
  imageGallery_sv?: string[];
  imageGallery_en?: string[];
}

export function mainImageForLanguage(product: ProcessedProductMedia, language: ProductImageLanguage): string {
  return (language === "sv" ? product.mainImage_sv : product.mainImage_en) || product.mainImage || "";
}

export function galleryForLanguage(product: ProcessedProductMedia, language: ProductImageLanguage): string[] {
  const localized = language === "sv" ? product.imageGallery_sv : product.imageGallery_en;
  return Array.isArray(localized) ? localized : product.imageGallery || [];
}

export function localizedImageUrls(product: ProcessedProductMedia): string[] {
  return [product.mainImage_sv, product.mainImage_en, ...(product.imageGallery_sv || []),
    ...(product.imageGallery_en || [])].filter((url): url is string => !!url);
}
